module.exports = __webpack_public_path__ + "04_veryshort_brown.65f754b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_veryshort_brown.png
// module id = K/Qr
// module chunks = 0